import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $id: String!
    $data: CultureUpdateInput!
  ) {
    updateOneCulture(
      where: { id: $id }
      data: $data
    ) {
      varieties {
        id
        name
        cicle
      }
    }
  }
`

export default () => (
  useMutation(MUTATION, `Variedade criada`, mutationTypes.CREATE)
)
